import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { DEVICE_INFO_API_URL } from '../../config';
import { readFromStorage, removeFromStorage } from '../webStorage';
import userAxios from './user.axios';

const axiosConfig: AxiosRequestConfig = {
    baseURL: `${DEVICE_INFO_API_URL}` || 'http://localhost:3000/',
};

const deviceAxios = axios.create(axiosConfig);

const logout = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('user');
    removeFromStorage('role');
    window.location.reload();
    // (window as any).Intercom('shutdown');
};

// reqeust intercpetor
deviceAxios.interceptors.request.use((config) => {
    const token = readFromStorage('accessToken');
    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...config,
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return config;
});

// Add a response interceptor
deviceAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const token = readFromStorage('refreshToken');
                    const role = localStorage.getItem('roles')
                    let response: any
                    let accessToken:  any
                    if (role === 'agents') {
                        response = await userAxios.put('/hotel-world-dom/access-token', { token });
                         accessToken = response.data.data.accessToken;
                    } else {
                        response = await userAxios.post('/dom/refresh-token', { token });
                        accessToken = response.data.data.token;
                    }
                    localStorage.setItem('accessToken', accessToken);
                    axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
                    return deviceAxios(originalRequest);
                } catch (e) {
                    console.error(e);
                    logout();
                }
            } else {
                logout();
            }
        }
        return Promise.reject(err);
    },
);

export const deviceAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
		params?: AxiosRequestConfig['params']
    }> =>
        async ({ url, method, data, params }) => {
            const baseUrl = axiosConfig.baseURL;
            try {
                const result = await deviceAxios({ url: baseUrl + url, method, data, params });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            };
        };

export default deviceAxios;
